import React from 'react';
import { getBezierPath, useStoreState } from 'react-flow-renderer';
export const ActionConnectionLine = ({
  sourceX,
  sourceY,
  sourcePosition,
  targetX,
  targetY,
  targetPosition
}) => {
  const edgePath = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition
  });
  const [,, zoom] = useStoreState(state => state.transform);
  const width = 2 / zoom;
  return /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#222",
    strokeWidth: width,
    d: edgePath
  }));
};